export default {
    title: 'Components/Cards/Image Card',
    tags: ['autodocs'],
    argTypes: {
      image_src: {
        control: 'text',
        description: 'Path to the image of the team member',
      },
      image_alt: {
        control: 'text',
        description: 'Path to the image of the team member',
      },
      header_text: {
        control: 'text',
        description: 'Header text for the information card',
      },
      date_text: {
        control: 'text',
        description: 'Date text for the information card',
      },
      body_text: {
        control: 'text',
        description: 'Body text for the information card',
      },

      left_button_color:{
        control: { type: 'text' },
        description: 'Button Color',
      },
      left_button_name: {
        control: 'text',
        description: 'Name of the left button',
      },
      left_button_href: {
        control: 'text',
        description: 'Href for the right button (link)',
      },
      left_button_rel: {
        control: 'text',
        description: 'Href for the right button (link)',
      },
      left_button_start_icon: {
        control: 'text',
        description: 'Button Start icon',
      },
      left_button_end_icon: {
        control: 'text',
        description: 'Button End icon',
      },
      left_button_data_fancybox: {
        control: { type: 'text' },
        description: 'GalleryOne',
      },
      left_button_target: {
        control: { type: 'text' },
        description: 'target blank',
      },
      
      right_button_color:{
        control: { type: 'text' },
        description: 'Button Color',
      },
      right_button_name: {
        control: 'text',
        description: 'Name of the right button',
      },
      right_button_href: {
        control: 'text',
        description: 'Href for the right button (link)',
      },
      right_button_rel: {
        control: 'text',
        description: 'Href for the right button (link)',
      },
      right_button_start_icon: {
        control: 'text',
        description: 'Button Start icon',
      },
      right_button_end_icon: {
        control: 'text',
        description: 'Button End icon',
      },
      right_button_data_fancybox: {
        control: { type: 'text' },
        description: 'GalleryOne',
      },
      right_button_target: {
        control: { type: 'text' },
        description: 'target blank',
      },

      file_size: {
        control: 'text',
        description: 'File size Information',
      },
      file_type: {
        control: 'text',
        description: 'File extention Information',
      },
      custom_class: {
        control: { type: 'text' },
        description: 'Custom class for the credit card component',
      },
      component_mode: {
        control: { type: 'check' },
        options: ['light-mode'],
        description: 'Mode of the credit card component',
      }
    },
    parameters: {
      docs: {
        description: {
          component: `
  To use the \`dda-image-card\` component, pass the following props:
  
  \`\`\`html
<dda-image-card
    image_src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvhlzYedWoCSkLB2HFQ87P5gPjCmJqmTt8vw&s"
    image_alt="alternate text"
    header_text="Backend Team"
    date_text="31 September 2024"
    body_text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    
    left_button_color="default-tertiary"
    left_button_name="Cancel"
    left_button_href="https://example.com"
    left_button_rel=""
    left_button_start_icon=""
    left_button_end_icon=""
    left_button_data_fancybox=""
    left_button_target=""
    
    right_button_color="default-primary"
    right_button_name="Continue"
    right_button_href="https://example.com"
    right_button_rel=""
    right_button_start_icon=""
    right_button_end_icon=""
    right_button_data_fancybox=""
    right_button_target=""

    file_size="Size: "
    file_type="Type: "
    custom_class=""
    component_mode=""
></dda-image-card>
    \`\`\`
  `,
        },
      },
    },  
  };
  
  const Template = (args) => {
    const attributes = Object.entries(args)
      .filter(([key, value]) => value !== undefined && key !== 'text')
      .map(([key, value]) => `${key}="${value}"`)
      .join(' ');
  
    return `<dda-image-card ${attributes}></dda-image-card>`;
  };
  
  export const Default = Template.bind({});
  Default.args = {
    image_src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvhlzYedWoCSkLB2HFQ87P5gPjCmJqmTt8vw&s',
    image_alt:"alternate text",
    header_text: "Backend Team",
    date_text: "31 September 2024",
    body_text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    
    left_button_color: "default-tertiary",
    left_button_name: "Cancel",
    left_button_href: "https://example.com",
    left_button_rel: "",
    left_button_start_icon: "",
    left_button_end_icon: "",
    left_button_data_fancybox: "",
    left_button_target: "",
    
    right_button_color:"default-primary",
    right_button_name: "Continue",
    right_button_href: "https://example.com",
    right_button_rel: "",
    right_button_start_icon: "",
    right_button_end_icon: "",
    right_button_data_fancybox: "",
    right_button_target: "",

    file_size: "Size: ",
    file_type: "Type: ",
    custom_class: '',
    component_mode: '',
  };